export default __webpack_public_path__ + "img/location-inside.43638af0.svg";